export const searchMarkerIconService = {
  getSeachIcon: function (color = "red") {
    return `<?xml version="1.0" ?>
    <svg width="60" height="60" id="Layer_1" style="enable-background:new 0 0 512 512;"
     version="1.1" viewBox="0 0 512 512" xml:space="preserve" 
     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<path fill="#FF0000"  class="st0" d="M256,76.8c-69,0-125,58.6-125,130.9c0,72.3,105.3,227.6,125,227.6S381,280,381,207.7  C381,135.4,325,76.8,256,76.8z M256,259c-33.2,0-60.1-26.9-60.1-60.2c0-33.2,26.9-60.1,60.1-60.1s60.1,26.9,60.1,60.1  C316.1,232,289.2,259,256,259z"/></svg>`;
  },
};
